import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { ProductStatus } from '@ibk/shared-types';
import { Icon } from '../Icon';
import { ProgressItem } from '../ProgressItem';
import styles from './ProductCard.module.css';
export default function ProductCard({ id, title, icon, status, onClick, 'data-testid': dataTestId, statusElement, isLoading = false, }) {
    const { t } = useTranslation();
    const getStatusText = (productStatus) => {
        switch (productStatus) {
            case ProductStatus.CONTRACTED:
                return t('products.status.contracted');
            case ProductStatus.NOT_CONTRACTED:
                return t('products.status.not-contracted');
            case ProductStatus.ACTIVATE:
                return t('products.status.activate');
            case ProductStatus.ACTIVE:
                return t('products.status.active');
            case ProductStatus.ANALYSIS:
                return t('products.status.account-analysis');
            case ProductStatus.NOT_APPROVED:
                return t('products.status.not-approved');
            case ProductStatus.LOADING:
                return t('products.status.loading');
            default:
                return t('products.status.not-contracted');
        }
    };
    const getStatus = (productStatus) => {
        return (_jsx("span", { className: styles.status, "data-testid": `product-card-status-${id}`, children: statusElement ?? getStatusText(productStatus) }));
    };
    const getAriaLabel = (productStatus) => {
        switch (productStatus) {
            case ProductStatus.CONTRACTED:
                return t('products.aria-label.contracted', { productName: title });
            case ProductStatus.NOT_CONTRACTED:
                return t('products.aria-label.not-contracted', { productName: title });
            case ProductStatus.ACTIVATE:
                return t('products.aria-label.activate', { productName: title });
            case ProductStatus.ACTIVE:
                return t('products.aria-label.active', { productName: title });
            case ProductStatus.ANALYSIS:
                return t('products.aria-label.account-analysis', { productName: title });
            case ProductStatus.NOT_APPROVED:
                return t('products.aria-label.not-approved', { productName: title });
            default:
                return t('products.aria-label.not-contracted', { productName: title });
        }
    };
    const ariaLabel = getAriaLabel(status);
    return (_jsxs("button", { className: status === ProductStatus.CONTRACTED || status === ProductStatus.ACTIVE ? styles.cardContracted : styles.card, onClick: () => onClick(id), "aria-label": ariaLabel, tabIndex: 0, type: 'button', "data-testid": dataTestId ?? `product-card-${id}`, children: [_jsx("div", { className: styles.iconContainer, "data-testid": `product-card-icon-${id}`, children: icon }), _jsxs("div", { className: styles.content, "data-testid": `product-card-content-${id}`, children: [_jsx("h3", { className: styles.title, "data-testid": `product-card-title-${id}`, children: title }), _jsx("div", { className: styles.statusContainer, "data-testid": `product-card-status-container-${id}`, children: getStatus(status) })] }), isLoading ? (_jsx(ProgressItem, { size: 16, variant: 'active', className: styles.progressIndicator, "data-testid": `product-card-progress-${id}` })) : (_jsx(Icon, { name: 'arrowChevronRight', className: styles.chevron, "data-testid": `product-card-chevron-${id}`, "aria-hidden": 'true' }))] }));
}
